<template>
    <div class="post-tags text-muted small" v-if="tags.length > 0">
        Từ khóa:
        <a v-for="tag in tags" :key="tag.id" :href="root.url('post_tag', { slug: tag.slug, id: tag.id })"
           class="badge badge-light mr-1">{{ tag.name }}</a>
    </div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue'
import axios from 'axios'

const props = defineProps({
    postId: {
        type: Number,
        required: true
    }
})

const root = inject('root')
const tags = ref([])
const errors = ref([])

const fetchTags = async () => {
    try {
        const baseUri = process.env.MOVEEK_API_ENDPOINT
        const response = await axios.get(`${baseUri}/v1/tags?post.id=${props.postId}`)
        tags.value = response.data
    } catch (error) {
        errors.value.push(error)
    }
}

onMounted(() => {
    fetchTags()
})
</script>

<style scoped>
</style>